import { mapGetters } from "vuex"

export default {
    computed: mapGetters(['getModulos']),
    methods: {
        authorize(action) {
            return this.getModulos && !!this.getModulos.find(modulo => {
                return !!modulo.funcionalidades.find(funcionalidade => {
                    return !!funcionalidade.acoes.find(acao => {
                        return `${modulo.prefixo}-${funcionalidade.prefixo}-${acao.prefixo}` === action
                    })
                })
            })
        },
    },
}